import { connect } from 'react-redux';

import {
  getProductDisplayPrice,
  getProductFormattedPriceRange,
} from 'redux/modules/product-details/selectors/product-pricing';

import ProductPrice from './ProductPrice';

export default connect((state, { productId }) => {
  return {
    displayPrice: getProductDisplayPrice(state, productId),
    formattedPriceRange: getProductFormattedPriceRange(state, productId),
  };
})(ProductPrice);
